import React, { Component } from 'react';
import ExpandedAssetUI from './media_library.expanded_asset.ui.jsx';
import includes from 'lodash/includes';
import autobind from 'class-autobind';

import { defaultDatetimeFormat } from 'zoomforth_zfutils/datetime_formatting.js';
import { makeVideoishPlayerSourcesForAsset } from 'zoomforth_tools/videoish_player.js';

import { isVideoishAssetType } from '../lib/assets.js';

const NEEDS_LOADING_ASSET_TYPES = ['pdf', 'html_package'];

class ExpandedAsset extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: includes(NEEDS_LOADING_ASSET_TYPES, props.asset.get('assetType'))
    };
    autobind(this);
  }

  componentDidMount() {
    document.addEventListener('keyup.expanded-asset', this.handleEscapeKeyUp);

  }

  componentWillUnmount() {
    document.removeEventListener('keyup.expanded-asset', this.handleEscapeKeyUp);
  }

  handleEscapeKeyUp(e) {
    if (e.keyCode === 27) { // ESC key
      this.props.onClose();
    }
  }

  getVideoishSources() {
    if (!isVideoishAssetType(this.props.asset.get('assetType'))) {
      return null;
    }
    return makeVideoishPlayerSourcesForAsset(this.props.asset.toJSON());
  }

  render() {

    const {
      isLoading
    } = this.state;
    const {
      asset,
      isShowingInfoPanel,
      onClose
    } = this.props;

    const assetType = asset.get('assetType');

    return (
      <ExpandedAssetUI 
        assetType={assetType}
        createdAtFormatted={defaultDatetimeFormat(asset.getCreatedAt(), { includeTime:true })}
        description={asset.getDescription()}
        htmlPackageEntrypointUrl={asset.get('entrypointUrl')}
        isLoading={isLoading}
        isShowingInfoPanel={isShowingInfoPanel}
        lastModifiedAtFormatted={defaultDatetimeFormat(asset.getLastModifiedAt(), { includeTime:true })}
        pdfUrl={asset.get('link')}
        name={asset.getName()}
        otherDisplayImageUrl={assetType == 'other' ? asset.get('displayImage') : undefined}
        photoUrl={assetType == 'photo' ? asset.get('displayImage') : undefined}
        presentationDownloadLink={asset.get('downloadLink')}
        presentationSlides={asset.get('slides')}
        uploadPerson={asset.getUploadPerson()}
        videoishSources={this.getVideoishSources()}
        videoishSubtitles={asset.get('subtitles')}
        videoishPosterUrl={isVideoishAssetType(assetType) ? asset.get('displayImage') : undefined}
        onClose={onClose}
        onPdfLoad={()=> { this.setState({ isLoading:false }); }}
        onHtmlPackageLoad={()=> { this.setState({ isLoading:false }); }}
      />
    );
  }
}

              


export default ExpandedAsset;